// src/App.tsx
import React, { Suspense, lazy } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion, Transition } from 'framer-motion';
import './App.css'; // global stiller, tailwind vs.
// Sabit kalan layout parçaları
import Navigation from './components/Navigation'; // Next'teki nav'ın React versiyonu
import Footer from './components/Footer';         // basit bir footer bileşeni önerilir
import FloatingActionButtons from './components/FloatingActionButtons';

// Sayfalar (isteğe göre lazy)
const Home = lazy(() => import('./pages/Home'));
const Hakkimizda = lazy(() => import('./pages/Hakkimizda'));
const Odalar = lazy(() => import('./pages/Odalar'));
const OdaDetay = lazy(() => import('./pages/OdalarDetay'));
const Galeri = lazy(() => import('./pages/Galeri'));
const Iletisim = lazy(() => import('./pages/Iletisim'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Basit bir sayfa geçiş animasyonu
const pageVariants = {
  initial: { opacity: 0, y: 8 },
  enter:   { opacity: 1, y: 0 },
  exit:    { opacity: 0, y: -8 },
};
const pageTransition: Transition = {
  type: 'tween',
  duration: 0.5,
  ease: 'easeOut',
};
function PageMotion({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      initial="initial"
      animate="enter"
      exit="exit"
      variants={pageVariants}
      transition={pageTransition}
      className="min-h-[60vh]" // içerik kısa olsa bile footer yukarı yapışmasın
    >
      {children}
    </motion.div>
  );
}

export default function App() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      {/* <ScrollToTop /> */}

      <main className="container  px-4 py-8">
        <Suspense fallback={<div className="py-16 text-center">Yükleniyor…</div>}>
          <AnimatePresence mode="wait">
            {/* location + key ile orta alan animasyonlu değişir */}
            <Routes location={location} key={location.pathname}>
              <Route
                path="/"
                element={
                  <PageMotion>
                    <Home />
                  </PageMotion>
                }
              />
              <Route
                path="/hakkimizda"
                element={
                  <PageMotion>
                    <Hakkimizda />
                  </PageMotion>
                }
              />
              <Route
                path="/odalar"
                element={
                  <PageMotion>
                    <Odalar />
                  </PageMotion>
                }
              />
              <Route path="/odalar/:id" element={<OdaDetay />} />

              <Route
                path="/galeri"
                element={
                  <PageMotion>
                    <Galeri />
                  </PageMotion>
                }
              />
              <Route
                path="/iletisim"
                element={
                  <PageMotion>
                    <Iletisim />
                  </PageMotion>
                }
              />
              <Route
                path="*"
                element={
                  <PageMotion>
                    <NotFound />
                  </PageMotion>
                }
              />
            </Routes>
          </AnimatePresence>
        </Suspense>
      </main>

      <Footer />
      <FloatingActionButtons
        phone="+905062562324"
        whatsapp="+905062562324"
        whatsappMessage="Merhaba, Nazilli Family Apart hakkında bilgi almak istiyorum."
      />
    </div>
  );
}
